<template>
	<div class="container-fluid" id="content-customer">
		<div class="row">
			<div
				class="col-sm-12 col-md-6 col-lg-4 col-xl-3"
				id="s-f-r"
				style="padding: 0px"
			>
				<div class="card box_custom search-box">
					<headList></headList>
					<searchList></searchList>
					<div id="demo"
						:class="[
						'comment-widgets srollclientes ',
						show_customer_setting ? 'show_customer' : '',
						showCustomer ? 'show_customer_body_list' : 'hide_customer_body_list',
						only_mobile ? 'only_mobile' : '',
						]"
					>
						<bodyList></bodyList>
					</div>
				</div>
			</div>
			<div class="col-sm-12 col-md-6 col-lg-8 col-xl-9 right-contenendor">
				<div class="card">
					<div class="content-default-customer"
						@statusContent="EmitMethodStatus"
						v-if="ShowDefaultContentCustomer"
					>
						<counterCustomer></counterCustomer>
					</div>
                    <div class="content-detail-customer" v-if="detailcontent">
						<dataCustomer></dataCustomer>
                    </div> 					                  
					<div class="content-form-register" v-if="registerForm">
						<formCustomer></formCustomer>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import counterCustomer from '@/apps/billing/components/customer/counterCustomer'
import dataCustomer from '@/apps/billing/components/customer/dataCustomer'
import headList from '@/apps/billing/components/customer/list/headList'
import searchList from '@/apps/billing/components/customer/list/searchList'
import bodyList from '@/apps/billing/components/customer/list/bodyList'
import formCustomer from '@/apps/billing/components/customer/formCustomer'
export default {
	name: "CustomerPage",
	components: {
        counterCustomer,
        dataCustomer,
        headList,
        searchList,
        bodyList,
        formCustomer,
	},
	data () {
		return {
			isLoading: false,
            showCustomer: false,
            only_mobile: false,
            ShowDefaultContentCustomer: true,
            registerForm: false,
            customerDetail: null,
            detailcontent: false,
            firstLoad: false,
            show_customer_setting: true,
			customerID: 0,
		};
	},
	created () {
		this.$store.commit('ModApps/billing/setCustomerCountTotal', null);
	},
	mounted () {
		this.only_mobile = (window.innerWidth <= 767);
	},
	directives: {
	},
	methods: {
		EmitMethodStatus() {
			this.ShowDefaultContentCustomer = true;
		},
		showformregister() {
			this.ShowDefaultContentCustomer = false;
			this.detailcontent = false;
			this.registerForm = true;
			if (window.innerWidth <= 767) {
				document.getElementById("s-f-r").style.display = "none";
			}
		},
		showDetails(){
			let t = this
			this.isLoading = true
			this.detailcontent = true
			this.ShowDefaultContentCustomer = false
			this.registerForm = false
			this.showCustomer = (window.innerWidth > 768);
			console.log('showDetails from mobile', this.showCustomer);
			setTimeout(function () {
				t.isLoading = false
			}, 1000);
		},
	},
	computed: {
		...mapGetters("ModApps/billing", {
			getCustomerID: "getCustomerID",
			getFormCustomer: "getFormCustomer",
			getShowSetting: "getShowSetting",
			getCustomerSearch: "getCustomerSearch",
			getResponseMail: "getResponseMail",
			getCustomerFirstLoadData: "getCustomerFirstLoadData",
			getCustomerSearchIsWriting: "getCustomerSearchIsWriting",
		}),
	},
	watch: {
		getShowSetting: function () {
			this.show_customer_setting = this.getShowSetting.show_customer;
		},
		getCustomerFirstLoadData: function (newVal) {
			if(!this.firstLoad && newVal) {
				this.firstLoad = true;
				this.showCustomer = newVal;
				console.log('getCustomerFirstLoadData', this.showCustomer);
			}
		},
		getFormCustomer: function () {
			if(this.getFormCustomer) {
				this.showformregister();
			}
			else if(this.getCustomerID > 0) {
				this.showDetails();
			}
			else {
				this.detailcontent = false;
				this.registerForm = false;
				this.ShowDefaultContentCustomer = true;
			}
		},
		getCustomerID: function () {
			if(this.getCustomerID > 0) {
				this.detailcontent = true;
				this.ShowDefaultContentCustomer = false;
				this.registerForm = false;
				this.showDetails();
			}
			else if(this.getCustomerID == 0 && this.getFormCustomer) {
				this.showformregister();
			}
			else {
				this.ShowDefaultContentCustomer = true;
				this.detailcontent = false;
				this.registerForm = false;
			}
		},
		getCustomerSearch: function () {
			// if (this.getCustomerSearch.length > 0) {}
		},
		getCustomerSearchIsWriting: function () {
			this.showCustomer = (this.getCustomerSearchIsWriting && window.innerWidth <= 768);
			console.log('getCustomerSearchIsWriting', this.showCustomer);
		},
		getResponseMail: function () {
			let item = this.getResponseMail;
			if (item.DataItem.send == 1) {
				item.DataItem.send = 0;
				this.$store.commit("core/setCloseModal", {
					action: 'sendMailInvoice',
				});
				this.$notify({
					group: "noti",
					title: "Success",
					type: "success",
					text: "Send Mail!",
				});
				this.$store.commit("ModApps/billing/SetResponseMail", null);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
#content-customer {
	margin-top: 5px;
	margin-left: -5px;
	padding-top: 0px;
	padding-left: 15px;
	padding-right: 10px;
	background: #fff;
}
.right-contenendor {
	padding: 0px;
	border-left: 1px solid #c9cbcc;
}
@media (min-width: 1366px){
	.srollclientes{
		height: 70vh;
	}
}
@media (min-width: 1450px){
    .srollclientes{
		height: 77vh;
	}
}
@media (max-width: 767px) {
	.only_mobile {
		// position: absolute;
		// left: 0;
		// z-index: 9;
		width: 100%;
		height: 60vh;
		border-bottom: 2px solid #ddd;
	}
	.show_customer_body_list {
		display: block !important;
	}
	.hide_customer_body_list {
		display: none !important;
	}
}
</style>
